import { createContext, useContext, type ReactNode } from "react";
import type { RootStores } from "./rootStores.js";

// Hands the root stores to screen containers. Screens read store state through the
// viewmodel binding hooks (`@pack-it-up/viewmodel/bindings`), never the store library.
const StoresContext = createContext<RootStores | null>(null);

export const AppProvider = ({ stores, children }: { stores: RootStores; children: ReactNode }): ReactNode => (
  <StoresContext.Provider value={stores}>{children}</StoresContext.Provider>
);

export const useStores = (): RootStores => {
  const stores = useContext(StoresContext);
  if (stores === null) throw new Error("useStores must be used within <AppProvider>");
  return stores;
};
